import moment from "moment";
class timePattern {
  constructor(
    empId,
    from,
    to,
    liqhs,
    late,
    retAnt,
    licPar,
    licTot,
    falls,
    hCaiTol,
    hCaiCsCostoId,
    autorizLiq,
    nameCost
  ) {
    if (autorizLiq) {
      if (autorizLiq == "N") {
        autorizLiq = "Nunca";
      } else if (autorizLiq == "T") {
        autorizLiq = "Siempre";
      } else if (autorizLiq == "D") {
        autorizLiq = "Predeterminado";
      } else {
        autorizLiq = "";
      }
    }
    this.empId = empId;
    this.from = moment.utc(from).format("DD-MM-YYYY");
    this.to = to == null ? " " : moment.utc(to).format("DD-MM-YYYY");
    this.liqhs = liqhs == "S" ? "✔️" : "";
    this.late = late == "S" ? "✔️" : "";
    this.retAnt = retAnt == "S" ? "✔️" : "";
    this.licPar = licPar == "S" ? "✔️" : "";
    this.licTot = licTot == "S" ? "✔️" : "";
    this.falls = falls == "S" ? "✔️" : "";
    this.hCaiTol = hCaiTol;
    this.hCaiCsCostoId = hCaiCsCostoId;
    this.autorizLiq = autorizLiq;
    this.nameCost = nameCost;
  }
  static fromJson({
    empId,
    fecDedse,
    fecHasta,
    liqHoras,
    tarde,
    retAnt,
    licPar,
    licTot,
    caidas,
    hCaiTol,
    hCaiCsCostoId,
    autorizLiq,
    hCaiCsCostoNombre,
  }) {
    return new timePattern(
      empId,
      fecDedse,
      fecHasta,
      liqHoras,
      tarde,
      retAnt,
      licPar,
      licTot,
      caidas,
      hCaiTol,
      hCaiCsCostoId,
      autorizLiq,
      hCaiCsCostoNombre
    );
  }
}
export default timePattern;
